/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RackByIdShelfResponse } from './rack-by-id-shelf-response';


export interface RackByIdResponse { 
    id: string;
    containerId: string;
    number: number;
    description?: string | null;
    socketTypeId: number;
    subnet: string;
    shelves?: Array<RackByIdShelfResponse> | null;
}

